import Store from "@/services/store";
import Router from "@/services/router";
import axios from "@/services/vue-axios";

export default {
  init() {
    console.info("Site module initialized.");
  },

  initModule({ dispatch }, module) {
    Store.registerModule(module.name, module.store);
    Router.addRoutes(module.routes);
    dispatch(module.name + "/init", null, { root: true });
  },

  clearWatch({ state }) {
    clearTimeout(state.connectionWatch);
  },

  resetWatch({ state, dispatch, commit }, expireDatetime) {
    if (typeof expireDatetime === "undefined") {
      expireDatetime = localStorage.expires_at;
    }

    dispatch("clearWatch");
    if (state.connected) {
      var interval =
        expireDatetime - Date.now() - process.env.VUE_APP_TIME_TO_REFRESH;

      var refresh = function() {
        dispatch("refresh");
      };

      var watch = setTimeout(refresh, interval);
      commit("connectionWatch", watch);
    }
  },

  initConnection({ commit }) {
    commit("connecting", true);
    commit("denied", false);
  },

  initReconnection({ commit }) {
    commit("reconnecting", true);
    commit("denied", false);
  },

  finishConnection({ commit, dispatch, state }) {
    commit("connecting", false);
    commit("reconnecting", false);
    if (state.connected) {
      dispatch("site/resetWatch", localStorage.expires_at, { root: true });
    }
  },

  checkConnection({ commit, state }) {
    commit("connected", Date.now() < localStorage.expires_at);
  },

  async refresh({ dispatch }) {
    const sleep = millis => {
      return new Promise(resolve => {
        setTimeout(resolve, millis);
      });
    };

    while (!navigator.onLine) {
      await sleep(1000);
    }

    dispatch("initReconnection");
    axios
      .post("/login/refresh")
      .then(response => {
        const newToken = response.data.access_token;
        const expires_in = response.data.expires_in;
        var t = new Date();
        const expire_date = t.setSeconds(t.getSeconds() + expires_in);
        localStorage.access_token = newToken;
        localStorage.expires_at = expire_date;
        dispatch("finishConnection");
      })
      .catch(error => {
        dispatch("finishConnection");
        return Promise.reject(error);
      });
  },

  login({ dispatch, commit }, { email, password }) {
    return new Promise((resolve, reject) => {
      var loginSuccessful = res => {
        const data = res.data;
        if (!data.access_token) {
          loginFailed();
        }
        localStorage.access_token = data.access_token;

        const expires_in = data.expires_in;
        var t = new Date();
        const expire_date = t.setSeconds(t.getSeconds() + expires_in);
        localStorage.expires_at = expire_date;
        endLogin();
        commit("user", data.user);

        // Only redirect if inside the connection page
        if (Router.currentRoute.path === process.env.VUE_APP_CONNECTION_ROUTE) {
          Router.push(process.env.VUE_APP_LOGIN_REDIRECT);
        }

        return resolve(res);
      };

      var loginFailed = error => {
        if (process.env.NODE_ENV !== "production") {
          console.log(error);
        }
        this.error = "Login failed!";
        delete localStorage.access_token;
        endLogin();
        return reject(error);
      };

      var endLogin = () => {
        dispatch("finishConnection");
      };

      dispatch("initConnection");

      axios
        .post(
          "/login",
          { email: email, password: password },
          { withCredentials: true, credentials: "include", mode: "cors" }
        )
        .then(request => loginSuccessful(request))
        .catch(error => loginFailed(error));
    });
  },

  logout({ commit, dispatch }) {
    var logoutSuccessful = function() {
      commit("user", null);
      commit("connected", false);
      dispatch("clearWatch");

      localStorage.removeItem("access_token");
      localStorage.removeItem("expires_at");
      Router.push("/");
    };

    var logoutFailed = function(error) {
      if (process.env.NODE_ENV !== "production") {
        console.log(error);
      }
      return Promise.reject(error);
    };

    axios
      .post(
        "/logout",
        {},
        { withCredentials: true, credentials: "include", mode: "cors" }
      )
      .then(response => logoutSuccessful())
      .catch(error => logoutFailed(error));
  },

  resetUser({ commit }) {
    commit("user", null);
  }
};
